module.exports = __webpack_public_path__ + "img/DE03943.f16fa730.png";